var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useDefaultApiParams } from 'src/hooks';
export const usePreviewOrder = (request) => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    return useQuery({
        queryKey: ['previewOrder', request, defaultApiParams],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return yield HandshakePainterServiceApiV1.previewOrder({
                previewOrderRequest: request,
                antiCsrftokenA2z: defaultApiParams.antiCsrftokenA2z,
                xJoinId: defaultApiParams.xJoinId,
                xUserLinked: defaultApiParams.xUserLinked,
                marketplaceId: defaultApiParams.marketplaceId,
            });
        }),
        // This is used to ensure preview is updated on customers changing their address.
        // Do not change.
        refetchOnWindowFocus: true,
    });
};
